import { createSlice } from "@reduxjs/toolkit";
import { GET_BY_ID_JOB_INTERPRETER_ACTION, GET_UNAVAILAVILITY_ACTION, INTERPRTER_RATE_AND_REVIEW_ACTION } from "./Interpreter.action";
const interpreterSlice = createSlice({
    name: "interpreter",
    initialState: {
        loading: false,
        error: null,
        legalDocumentTranslator: [],
        interpreter_rate_and_review: [],
        interpreter_unavailability: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_BY_ID_JOB_INTERPRETER_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_BY_ID_JOB_INTERPRETER_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.legalDocumentTranslator = action.payload;
            })
            .addCase(GET_BY_ID_JOB_INTERPRETER_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(INTERPRTER_RATE_AND_REVIEW_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(INTERPRTER_RATE_AND_REVIEW_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.interpreter_rate_and_review = action.payload;
            })
            .addCase(INTERPRTER_RATE_AND_REVIEW_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(GET_UNAVAILAVILITY_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_UNAVAILAVILITY_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.interpreter_unavailability = action.payload;
            })
            .addCase(GET_UNAVAILAVILITY_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default interpreterSlice;